module.exports = __webpack_public_path__ + "img/ico_barley_02.37101e46.svg";